import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const CountryFilterContainer = styled.div`
    width: 320px;
    & .DropdownButton--filtersBarDropdownButton {
        border: 1px solid ${colorsPalettes.carbon[50]};
    }
`;

export const CountryButtonContainer = styled.div`
    width: 100%;
`;
